import PropTypes from 'prop-types';
import React, { Component } from 'react';

class AutoAppointment extends Component {

    render() {

        const { task, selected_task, toggleSidebar } = this.props;
        const title = task.template_appointment ? task.template_appointment.name : <span className="text-danger"><i className="fas fa-exclamation-triangle mr-2" /> Appointment Template Not Set</span>

        return (

            <div className={selected_task === task._id ? "selected auto" : "auto"} >
                <div className="wrapper" onClick={() => toggleSidebar(true, task._id)}>
                    <div className="title">
                        <b><i className="fas fa-calendar mr-3 text-success" />Appointment: </b>
                        {title}
                    </div>
                </div>
            </div>

        )

    }

}

AutoAppointment.propTypes = {
    task            : PropTypes.object.isRequired,
    selected_task   : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    toggleSidebar   : PropTypes.func.isRequired,
}

export default AutoAppointment;
